import React, { Component } from 'react';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ReadingList from '../../../../Components-2025/QuestionBank/ReadingList';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import { showFailure, showInformation } from '../../../../common/toast';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import appRoutes from '../../../config/AppRoutes';
import alertMessage from '../../../config/alertMessage';
import { TotalNotesCountKey, chapterIdKey, chapterNameKey } from './ApiAttributesKays';
import apiServiceProvider from './ApiService';

export default class ReadingsList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      selectedExamSubscriptionDetails: {},
      chapterName: '',
      pdfAlert: false,
      openPremiumPopup: false,
      isUserSubscribed: false,
      readingListData: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { chapterId, level } = this.props.params;
    const fetchReadingListData = await apiServiceProvider['fetchReadingList']({ chapterId, level });
    if (fetchReadingListData.success) {
      const { readings, selectedExamSubscriptionDetails, chapterName } = fetchReadingListData;
      if (
        selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 ||
        selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${level}`] ||
        chapterId === '1' ||
        chapterId === '5'
      ) {
        this.setState({ isUserSubscribed: true });
      }

      this.setState({
        readingListData: readings,
        selectedExamSubscriptionDetails,
        isLoading: false,
        chapterName: Object.keys(chapterName).length && chapterName[chapterNameKey],
      });
    } else {
      const { router } = this.context;
      router.push({ pathname: appRoutes.FRM_V2_NOTES });
      showFailure(messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_CHAPTER);
    }
  }
  checkSubscription = async (cb, type) => {
    const { isUserSubscribed } = this.state;
    if (!isUserSubscribed) {
      return this.setState({ openPremiumPopup: true });
    }
    cb();
    this.setState({ PDFDownloadType: type });
    this.pdfAlertModel();
  };

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };
  pdfAlertModel = () => {
    this.setState({ pdfAlert: !this.state.pdfAlert });
  };

  onBeginChapter = items => {
    const { isUserSubscribed } = this.state;
    if (!items[TotalNotesCountKey]) {
      showInformation(messages.NOTES_NOT_AVAILABLE_FOR_READING);
    } else {
      if (!isUserSubscribed) {
        return this.setState({ openPremiumPopup: true });
      } else {
        const { router } = this.context;
        router.push({
          pathname: appRoutes.FRM_V2_NOTES_VIEW.replace(':level', items.level)
            .replace(':readingId', items.id)
            .replace(':chapterId', items[chapterIdKey]),
        });
      }
    }
  };
  render() {
    const { params } = this.props;
    const { chapterId, level } = params;
    const {
      chapterName,
      pdfAlert,
      openPremiumPopup,
      isUserSubscribed,
      readingListData,
      isLoading = false,
    } = this.state;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={`${chapterId}. ${chapterName}`}>
          <div>
            <CustomButton
              className='bg-completed-cases overflow-hidden max-width-min-content'
              onClick={() => {
                this.checkSubscription(
                  () =>
                    apiServiceProvider['pdfDownloadViaEmail']({
                      chapterId,
                      frmLevel: level,
                    }),
                  'Question',
                );
              }}
            >
              <i className='fa fa-download' aria-hidden='true' />
              {!isUserSubscribed && <div className='premium-download'>Premium</div>}
              {messages.DOWNLOAD_NOTE}
            </CustomButton>

            <CustomButton onClick={() => router.push({ pathname: appRoutes.FRM_V2_NOTES })}>
              {messages.CHANGE_TOPIC}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}========================================== */}
        <LoaderWrapper isLoading={isLoading}>
          <ReadingList
            tableName={messages.CHAPTER_READING}
            readingData={readingListData}
            onViewList={this.onViewList}
            isViewListIcon={false}
            onBeginChapter={this.onBeginChapter}
          />
        </LoaderWrapper>
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
        />

        {/* //* THIS IS PDF DOWNLOAD SUCCESS MODAL POP-UP  */}
        <PDFModelComponent
          type='Study Notes'
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={pdfAlert}
          PDFContentMessage={messages.PDF_DOWNLOAD_CONTENT_MESSAGE}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/ReadingList/ReadingsList.jsx